module.exports = __webpack_public_path__ + "static/sport/bgi-tag-left-active.900b443.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jump/bgi-tag-left-active.png
// module id = OcVW
// module chunks = 0